import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  checkQrCodeShopService,
  verifyQrCodeShopService,
} from "./../../../services/shopServices";
import {
  deliverySuccessMessage,
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { secondsCountDown } from "../../../utils";

export const qrCodeScannerShopContext = createContext({
  user: {},
  setUser: () => {},
  token: "",
  setToken: () => {},
  handleReset: () => {},
  handleCheckQrCode: () => {},
  handleVerifyQrCode: () => {},
});

const QrCodeScannerShopContext = ({ children }) => {
  const dispatch = useDispatch();

  const [user, setUser] = useState({});
  const [token, setToken] = useState("");

  const handleReset = () => {
    setUser({});
    setToken("");
  };

  // Check Qr Code
  const handleCheckQrCode = async (userData) => {
    const objData = {
      token,
      ...userData,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await checkQrCodeShopService(objData);
      if (status === 200) {
        const time = Math.floor(
          (new Date(data.result.expiredAt).getTime() - Date.now()) / 1000
        );
        if (time <= 0) {
          handleReset();
          toastErrorMessage("اعتبار توکن تمام شده است");
          return;
        }

        setUser(data.result.user);
        secondsCountDown("otpCountdown", time, handleReset);
        toastSuccessMessage(data.resultMessage);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Verify Qr Code
  const handleVerifyQrCode = async (userData) => {
    const objData = {
      ...userData,
      token,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await verifyQrCodeShopService(objData);
      if (status === 200) {
        deliverySuccessMessage(data.resultMessage);
        handleReset();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <qrCodeScannerShopContext.Provider
      value={{
        user,
        setUser,
        token,
        setToken,
        handleReset,
        handleCheckQrCode,
        handleVerifyQrCode,
      }}
    >
      {children}
    </qrCodeScannerShopContext.Provider>
  );
};

export default QrCodeScannerShopContext;
